import React from 'react';
import { motion } from 'framer-motion';
import { StethoscopeIcon, BrainIcon, GraduationCapIcon, HeartPulseIcon, ShieldCheckIcon, AwardIcon } from 'lucide-react';
export function Services() {
  const medicalServices = [{
    title: 'Family Practice & Lifestyle Wellness',
    items: ['Preventive care and wellness exams', 'Chronic disease management', 'Lifestyle counseling', 'Wellness planning']
  }, {
    title: 'Health Risk Assessments (HRAs)',
    items: ['Comprehensive health evaluations', 'Risk identification', 'Preventive planning']
  }, {
    title: 'Critical Care Consultation',
    items: ['Clinical consultation', 'Care coordination', 'Post-hospital recovery support']
  }, {
    title: 'Consultation & Training',
    items: ['Healthcare consultation', 'Mental wellness workshops', 'Organizational wellness programs']
  }];
  const mentalHealthServices = [{
    title: 'Family and Marriage Coaching',
    items: ['SYMBIS Marriage Facilitation', 'Couples Repair Specialist', 'Relationship restoration']
  }, {
    title: 'Trauma and PTSD Support',
    items: ['Trauma recovery', 'Emotional healing', 'PTSD support']
  }, {
    title: 'Mood Disorders Support',
    items: ['Anxiety and Depression support', 'Loneliness and Isolation support']
  }, {
    title: 'Specialized Coaching',
    items: ['Grief and Loss Support', 'Youth and Adolescent Coaching', 'Geriatric Mental Wellness', 'Life Recovery and Purpose Coaching']
  }];
  return <main className="bg-[#F8F9FA] py-20" data-id="element-358">
      <div className="container mx-auto px-4" data-id="element-359">
        <div className="text-center mb-16" data-id="element-360">
          <h1 className="text-5xl font-serif text-[#588157] mb-6" data-id="element-361">
            Our Comprehensive Services
          </h1>
          <p className="text-xl text-[#1A374D]/70 max-w-3xl mx-auto" data-id="element-362">
            Integrating primary healthcare and mental wellness to provide a
            holistic approach to your total well-being.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-363">
          {/* Medical Services Column */}
          <div className="space-y-8" data-id="element-364">
            <div className="flex items-center gap-4 mb-8" data-id="element-365">
              <div className="w-12 h-12 bg-[#588157] rounded-xl flex items-center justify-center text-white" data-id="element-366">
                <StethoscopeIcon size={24} data-id="element-367" />
              </div>
              <h2 className="text-3xl font-serif text-[#588157]" data-id="element-368">
                Medical & Wellness
              </h2>
            </div>

            <div className="grid gap-6" data-id="element-369">
              {medicalServices.map((service, idx) => <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.1
            }} key={service.title} className="bg-white p-8 rounded-2xl shadow-sm border border-[#588157]/5" data-id="element-370">
                  <h3 className="text-xl font-bold text-[#588157] mb-4" data-id="element-371">
                    {service.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-372">
                    {service.items.map(item => <li key={item} className="flex items-center gap-2 text-[#1A374D]/80" data-id="element-373">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#D4A373]" data-id="element-374" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>

          {/* Mental Health Column */}
          <div className="space-y-8" data-id="element-375">
            <div className="flex items-center gap-4 mb-8" data-id="element-376">
              <div className="w-12 h-12 bg-[#D4A373] rounded-xl flex items-center justify-center text-white" data-id="element-377">
                <BrainIcon size={24} data-id="element-378" />
              </div>
              <h2 className="text-3xl font-serif text-[#588157]" data-id="element-379">
                Mental Health & Coaching
              </h2>
            </div>

            <div className="grid gap-6" data-id="element-380">
              {mentalHealthServices.map((service, idx) => <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: idx * 0.1
            }} key={service.title} className="bg-white p-8 rounded-2xl shadow-sm border border-[#588157]/5" data-id="element-381">
                  <h3 className="text-xl font-bold text-[#588157] mb-4" data-id="element-382">
                    {service.title}
                  </h3>
                  <ul className="space-y-2" data-id="element-383">
                    {service.items.map(item => <li key={item} className="flex items-center gap-2 text-[#1A374D]/80" data-id="element-384">
                        <div className="w-1.5 h-1.5 rounded-full bg-[#588157]" data-id="element-385" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>)}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-20 bg-[#588157] rounded-3xl p-12 text-center text-white" data-id="element-386">
          <h2 className="text-3xl font-serif mb-6" data-id="element-387">Not sure where to start?</h2>
          <p className="text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-388">
            Schedule a consultation with our team to discuss your needs and
            develop a personalized restoration plan.
          </p>
          <button onClick={() => window.location.hash = '#contact-us'} className="px-10 py-4 bg-[#D4A373] text-white font-bold rounded-full hover:bg-[#c29263] transition-all" data-id="element-389">
            Book a Consultation
          </button>
        </div>
      </div>
    </main>;
}